export function substituteVars(sql, vars) {
  if (!vars) return sql;
  let result = sql;
  for (const [key, value] of Object.entries(vars)) {
    result = result.replaceAll(key, value);
  }
  return result;
}
